import { ICellRendererParams } from "ag-grid-community";
import * as _ from "lodash";

export const agGridDocumentsSettings = {
  rowModelType: 'infinite',
  //rowModelType: "'serverSide'",
  //pagination: true,
  //virtualPaging: true, // this is important, if not set, normal paging will be done
  //enableServerSideSorting: true,
  //enableServerSideFilter: true,
  rowSelection: 'single',
  //rowDeselection: true,
  rowHeight: 40,
  enableRangeSelection: true,
  cacheBlockSize: 10,
  paginationPageSize: 30,
  infiniteInitialRowCount: 2,
  statusBar: {
    statusPanels: [
      { statusPanel: 'statusBarComponent', align: 'center' },
      { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
      { statusPanel: 'agTotalRowCountComponent', align: 'left', key: 'statusBarCompKeyRowCount' },
      { statusPanel: 'agFilteredRowCountComponent' },
      { statusPanel: 'agSelectedRowCountComponent' },
      {
        statusPanel: 'agAggregationComponent',
        key: 'statusBarCompKey',
        statusPanelParams: {
          aggFuncs: ['sum', 'count', 'min', 'max', 'avg']
        }
      }
    ]
  },
  columnDefs: [
    // {
    //   cellRenderer: 'buttonRenderer',
    //   cellRendererParams: {
    //     text: 'name',
    //     routerLinkValue: (params: ICellRendererParams) => `${_.get(params, 'data.id')}/edit-document`
    //   }
    // },
    { field: 'name', headerName: "Documents", sortable: true, filter: true}
    //{field: 'name', headerName: "Documents", sortable: true, filter: true,},
    //     {
    //     cellRenderer:'buttonRenderer',
    //     cellRendererParams: {
    //       icon_visibility:'visibility',
    //       routerLinkValue: (params: ICellRendererParams) => `${_.get(params, 'data.id')}/edit-document`
    //     }
    // }
  ],
  defaultColDef: {
    enableValue: true,
    //sortable: true,
    enableRowGroup: true,
    resizable: true,
    // filter: true,
    enablePivot: true,
    editable: true
  }
}
